import { render } from "./index.vue?vue&type=template&id=d01d0d60"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=d01d0d60&lang=scss"
script.render = render

export default script